module.exports = __webpack_public_path__ + "img/certificate-1.4cac4de3.jpg";